import { isAxiosError } from 'axios'
import { call, put, select, takeEvery } from 'redux-saga/effects'

import * as ProgramRest from '@app/domain/program/program.rest'
import type { AppAction, AppState } from '@app/state'

import * as ProgramState from './state'

import type { AxiosResponse } from 'axios';

function* createProgram(action: AppAction) {
  if (action.type === ProgramState.ActionType.CreateProgram) {
    const appState: AppState = yield select((a) => a)
    try {
      const request = ProgramRest.createProgram(action.name)
      const response: AxiosResponse<ProgramRest.ICreateProgramResponse> =
        yield call(request, appState.config.apiLocation, appState.auth.token)

      if (response.status === 200) {
        yield put(ProgramState.actions.createProgramSucceeded())
      } else {
        if (ProgramRest.isICreateProgramErrorResponse(response.data)) {
          yield put(
            ProgramState.actions.createProgramFailed(
              response.data.error ?? 'Error creating program',
            ),
          )
        }
      }
    } catch (e) {
      if (isAxiosError(e) && e.response) {
        if (ProgramRest.isICreateProgramErrorResponse(e.response.data)) {
          yield put(
            ProgramState.actions.createProgramFailed(
              e.response.data.error ?? 'Error creating program',
            ),
          )
        } else {
          yield put(
            ProgramState.actions.createProgramFailed('Error creating program'),
          )
        }
      } else {
        yield put(ProgramState.actions.createProgramFailed('Unexpected error'))
      }
    }
  }
}

export function* handleCreateProgram() {
  yield takeEvery(ProgramState.ActionType.CreateProgram, createProgram)
}

export const sagas = {
  handleCreateProgram,
}
